import { Dialog, DialogContent } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import { usePaymentStyles } from '../classNames';
import { useApiData } from 'app/utils/helpers';
import { Elements } from '@stripe/react-stripe-js';
import PaymentMethodModalBody from './PaymentMehtodModalBody';
import { stripePromise } from 'app/utils/stripeLoader';
import StripeErrorBoundary from 'app/components/ErrorBoundaries/StripeErrorBoundary';

function PaymentMethodModal({ open, onClose }) {
  const classes = usePaymentStyles();
  const { client_secret } = useApiData('stripe', {});
  const appearance = {
    rules: {
      '.Label': {
        color: '#999',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '20px',
      },
    },
  };

  return (
    <Dialog open={open} classes={{ paper: classes.card }}>
      <DialogContent classes={{ root: classes.dialogContent }}>
        {/* Error boundary scoped to Stripe Elements only - prevents payment errors from closing the modal */}
        <StripeErrorBoundary>
          <Elements
            stripe={stripePromise}
            options={{ clientSecret: client_secret, appearance: appearance }}
          >
            <PaymentMethodModalBody onClose={onClose} />
          </Elements>
        </StripeErrorBoundary>
      </DialogContent>
    </Dialog>
  );
}
PaymentMethodModal.defaultProps = {
  open: false,
};
PaymentMethodModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};
export default PaymentMethodModal;
